import { Component, OnInit, Inject } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CarregandoService } from '../../services/carregando.service';
import { NotificacaoService } from '../../services/notificacao.service';
import { TagGiService } from '../../services/tag-gi.service';
import { Ibge } from '../../models/ibge';
import { IbgeService } from '../../services/ibge.service';
import { SegmentacaoService } from '../../services/segmentacao.service';
import { FormaDePagamentoService } from '../../services/forma-de-pagamento.service';
import { CondicaoDePagamentoService } from '../../services/condicao-de-pagamento.service';
import { opcoesTelhado } from 'src/app/globals';
import { ProdutoService } from '../../services/produto.service';
import { MarcaService } from '../../services/marca.service';
import swal from 'sweetalert2';
import { FiltroCarteiraIntegradores, FiltroCarteiraIntegradoresDeAte } from '../../models/FiltroCarteiraIntegradores';
import { TipoCampoFiltroCarteiraIntegradores, TipoFiltroCarteiraIntegradores, TipoTag } from '../../models/enum';
import { CarteiraDeIntegradoresFiltroBanco } from '../../models/carteira-de-integradores-filtro-banco';
import { CarteiraDeIntegradoresService } from '../../services/carteira-de-integradores.service';
import { CarteiraDeIntegradoresFiltrosService } from '../../services/carteira-de-integradores-filtros.service';
import { GlobalService } from '../../services/global.service';
import { PremissasService } from '../../services/premissas.service';
import { UsuarioLogado } from 'src/app/models/usuario-logado';
import { EstruturasPersonalizadas } from 'src/app/models/estruturas-personalizadas';
import { PremissasSistema } from "../../models/premissas-sistema";

@Component({
  selector: 'app-gerenciar-filtros-carteira-integradores-modal',
  templateUrl: './gerenciar-filtros-carteira-integradores-modal.component.html',
  styleUrls: ['./gerenciar-filtros-carteira-integradores-modal.component.scss']
})
export class GerenciarFiltrosCarteiraIntegradoresModalComponent implements OnInit {
  public config: PerfectScrollbarConfigInterface = {};

  idFiltro;
  descricaoFiltro;
  vendedorSelecionado;
  filtrosSelecionados;
  colunasSelecionadas;

  usuarioLogado: UsuarioLogado;

  confirmacao = [
    { id: 1, nome: 'Sim' },
    { id: 0, nome: 'Não' },
  ];

  tensoesMo = [{ id: 1, nome: '220' }];
  tensoesBi = [
    { id: 1, nome: '220' },
    { id: 2, nome: '380' },
  ];
  tensoesTri = [
    { id: 1, nome: '220' },
    { id: 2, nome: '380' },
    { id: 3, nome: '+380' },
  ];

  tiposDeStatus = [
    { id: 0, nome: 'Bloqueado' },
    { id: 1, nome: 'Ativo' }
  ];

  filtros: FiltroCarteiraIntegradores[] = [];

  modulosAtivos: Number[] = [];

  estruturasPersonalizadas: EstruturasPersonalizadas = new EstruturasPersonalizadas();

  premissasSistema: PremissasSistema = new PremissasSistema();

  constructor(
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private tagService: TagGiService,
    private ibgeService: IbgeService,
    private segmentacaoService: SegmentacaoService,
    private formadePagamentoService: FormaDePagamentoService,
    private condicaoDePagamentoService: CondicaoDePagamentoService,
    private produtoService: ProdutoService,
    private marcaService: MarcaService,
    private carteiraDeIntegradoresFiltrosService: CarteiraDeIntegradoresFiltrosService,
    private globalService: GlobalService,
    private premissasService: PremissasService,
    private dialogRef: MatDialogRef<GerenciarFiltrosCarteiraIntegradoresModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {  }

  async ngOnInit() {
    await this.buscarPremissasSistema();
  }

  async inicializacao() {
    this.usuarioLogado = await this.globalService.consultaUsuario();

    await this.buscarModulosAtivos();

    if (this.possuiModulo(2)) {
      this.buscarTags();
    } else {
      this.filtros = this.filtros.filter(p => p.descricao !== 'Tags');
    }

    this.buscarClassificacao();
    this.buscarFormasDePagamento();
    this.buscarMarcaInversores();
    this.buscarMarcaPaineis();
    this.buscarPaineis();
    this.buscarUsarTelhadoCeramico();
    this.buscarMostrarBifasico();

    this.recarregarFiltros();
  }

  async buscarPremissasSistema() {
    this.carregandoService.mostra('buscarPremissasSistema');
    this.premissasService.consultarPremissasSistema().subscribe(
      async (premissas) => {
        this.premissasSistema = premissas;

        this.populaFiltros();
        await this.inicializacao();
        this.carregandoService.esconde('buscarPremissasSistema');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissasSistema');
        this.notificacaoService.erro(erro);
      }
    );
  }

  populaFiltros() {
    this.filtros = [
      new FiltroCarteiraIntegradores(
        'Baseado na Usabilidade',
        TipoCampoFiltroCarteiraIntegradores.titulo
      ),
      new FiltroCarteiraIntegradores(
        'Fez login',
        TipoCampoFiltroCarteiraIntegradores.comboUnico,
        TipoFiltroCarteiraIntegradores.FezLogin,
      ),
      new FiltroCarteiraIntegradores(
        'Fez Orçamento',
        TipoCampoFiltroCarteiraIntegradores.comboUnico,
        TipoFiltroCarteiraIntegradores.FezOrcamento,
      ),
      new FiltroCarteiraIntegradores(
        'Fez Pedido',
        TipoCampoFiltroCarteiraIntegradores.comboUnico,
        TipoFiltroCarteiraIntegradores.FezPedido,
      ),
      new FiltroCarteiraIntegradores(
        'Baseado na Operação',
        TipoCampoFiltroCarteiraIntegradores.titulo
      ),
      new FiltroCarteiraIntegradores(
        'Atividades Pendentes',
        TipoCampoFiltroCarteiraIntegradores.comboUnico,
        TipoFiltroCarteiraIntegradores.AtividadesPendentes,
      ),
      new FiltroCarteiraIntegradores(
        'Forma de Pagamento',
        TipoCampoFiltroCarteiraIntegradores.comboUnico,
        TipoFiltroCarteiraIntegradores.FormaDePagamento,
        [],
        'descricao',
        'id',
        () => {
          this.buscarCondicoesDePagamento();
          this.limparCondicaoDePagamentoSelecionada();
        }
      ),
      new FiltroCarteiraIntegradores(
        'Condição de Pagamento',
        TipoCampoFiltroCarteiraIntegradores.comboUnico,
        TipoFiltroCarteiraIntegradores.CondicaoDePagamento,
        [],
        'descricao',
        'idCondPag',
        () => { },
        () => {
          this.filtros.find(p => p.id === TipoFiltroCarteiraIntegradores.FormaDePagamento).status = true;
        }
      ),
      new FiltroCarteiraIntegradores(
        'Classificação',
        TipoCampoFiltroCarteiraIntegradores.comboUnico,
        TipoFiltroCarteiraIntegradores.Classificacao,
        [],
        'descricao'
      ),
      new FiltroCarteiraIntegradores(
        'Tags',
        TipoCampoFiltroCarteiraIntegradores.comboMultiplo,
        TipoFiltroCarteiraIntegradores.Tags,
        [],
        'tag'
      ),
      new FiltroCarteiraIntegradores(
        'Venda Direta',
        TipoCampoFiltroCarteiraIntegradores.comboUnico,
        TipoFiltroCarteiraIntegradores.VendaDireta,
      ),
      new FiltroCarteiraIntegradores(
        'Status',
        TipoCampoFiltroCarteiraIntegradores.comboUnico,
        TipoFiltroCarteiraIntegradores.Status,
        this.tiposDeStatus,
      ),
      new FiltroCarteiraIntegradores(
        this.premissasSistema.habilitaOrcamento
          ? 'Quantitativo de Simulação | Orçamento | Pedido'
          : 'Quantitativo de Simulação | Pedido',
        TipoCampoFiltroCarteiraIntegradores.titulo,
      ),
      new FiltroCarteiraIntegradores(
        'UF',
        TipoCampoFiltroCarteiraIntegradores.comboUnico,
        TipoFiltroCarteiraIntegradores.UF,
        [
          'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI',
          'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
        ],
        'nome',
        'id',
        () => {
          this.buscarCidades();
          this.limparCidadeSelecionada();
        }
      ),
      new FiltroCarteiraIntegradores(
        'Cidade',
        TipoCampoFiltroCarteiraIntegradores.comboUnico,
        TipoFiltroCarteiraIntegradores.Cidade,
        [],
        'cidade',
        'cod',
        () => { },
        () => {
          this.filtros.find(p => p.id === TipoFiltroCarteiraIntegradores.UF).status = true;
        }
      ),
      new FiltroCarteiraIntegradores(
        'Fase',
        TipoCampoFiltroCarteiraIntegradores.comboUnico,
        TipoFiltroCarteiraIntegradores.Fase,
        [
          { id: 0, nome: 'Monofásica' },
          { id: 2, nome: 'Trifásica' }
        ], 'nome', 'id', () => {
          this.buscarTensoes();
          this.filtros.find(p => p.id === TipoFiltroCarteiraIntegradores.Tensao).valor = undefined;
        }
      ),
      new FiltroCarteiraIntegradores(
        'Tensão',
        TipoCampoFiltroCarteiraIntegradores.comboUnico,
        TipoFiltroCarteiraIntegradores.Tensao,
        [], 'nome', 'id',
        () => { },
        () => {
          this.filtros.find(p => p.id === TipoFiltroCarteiraIntegradores.Fase).status = true;
        }
      ),
      new FiltroCarteiraIntegradores(
        'Tipo Telhado',
        TipoCampoFiltroCarteiraIntegradores.comboUnico,
        TipoFiltroCarteiraIntegradores.TipoTelhado,
        [],
        'nome', 'id'
      ),
      new FiltroCarteiraIntegradores(
        'Inversor Marca',
        TipoCampoFiltroCarteiraIntegradores.comboUnico,
        TipoFiltroCarteiraIntegradores.InversorMarca,
        [],
        'descricao',
        'idMarca'
      ),
      new FiltroCarteiraIntegradores(
        'Painel Marca',
        TipoCampoFiltroCarteiraIntegradores.comboUnico,
        TipoFiltroCarteiraIntegradores.PainelMarca,
        [],
        'descricao',
        'idMarca'
      ),
      new FiltroCarteiraIntegradores(
        'Painel Potência',
        TipoCampoFiltroCarteiraIntegradores.comboUnico,
        TipoFiltroCarteiraIntegradores.PainelPotencia,
      ),
      new FiltroCarteiraIntegradores(
        'Potência',
        TipoCampoFiltroCarteiraIntegradores.campoDePara,
        TipoFiltroCarteiraIntegradores.Potencia, undefined, undefined, undefined, () => { }, () => { }, new FiltroCarteiraIntegradoresDeAte()
      ),
      new FiltroCarteiraIntegradores(
        'Consumo',
        TipoCampoFiltroCarteiraIntegradores.campoDePara,
        TipoFiltroCarteiraIntegradores.Consumo, undefined, undefined, undefined, () => { }, () => { }, new FiltroCarteiraIntegradoresDeAte()
      ),
    ];

    if (!this.premissasSistema.habilitaOrcamento) {
      this.filtros = this.filtros.filter(f => f.descricao !== 'Fez Orçamento');
    }
  }

  possuiModulo(modulo: Number) {
    return this.modulosAtivos.some(p => p === modulo);
  }

  async buscarModulosAtivos() {

    try {
      this.carregandoService.mostra('buscarModulosAtivos');

      this.modulosAtivos = await this.premissasService.consultarModulosAtivos().toPromise();

      this.carregandoService.esconde('buscarModulosAtivos');
    } catch (erro) {
      this.carregandoService.esconde('buscarModulosAtivos');
      this.notificacaoService.erro(erro);
    }
  }

  recarregarFiltros() {
    this.idFiltro = this.data.idFiltro;
    this.descricaoFiltro = this.data.descricaoFiltro;
    this.vendedorSelecionado = this.data.vendedorSelecionado;
    this.colunasSelecionadas = this.data.colunasSelecionadas;

    this.data.filtrosSelecionados.forEach(p => {
      if (this.filtros.some(c => c.id === p.id)) {
        const filtro = this.filtros.find(c => c.id === p.id);
        filtro.status = true;
        filtro.valor = p.valor;

        if (filtro.id === TipoFiltroCarteiraIntegradores.FormaDePagamento && filtro.status) {
          this.buscarCondicoesDePagamento();
        }

        if (filtro.id === TipoFiltroCarteiraIntegradores.UF && filtro.status) {
          this.buscarCidades();
        }

        if (filtro.id === TipoFiltroCarteiraIntegradores.Fase && filtro.status) {
          this.buscarTensoes();
        }
      }
    });
  }

  buscarTensoes() {
    this.filtros.find(p => p.id === TipoFiltroCarteiraIntegradores.Tensao).items = this.filtros.find(p => p.id === TipoFiltroCarteiraIntegradores.Fase).valor === 2 ? this.tensoesTri : this.filtros.find(p => p.id === TipoFiltroCarteiraIntegradores.Fase).valor === 1 ? this.tensoesBi : this.tensoesMo;
  }

  buscarPaineis() {
    this.carregandoService.mostra('buscarPaineis');

    this.produtoService.listarPorFamilia(2, true).subscribe(dados => {
      dados = [...new Set(dados.map(p => p.potencia))].sort((a: number, b: number) => (a - b));
      this.filtros.find(p => p.id === TipoFiltroCarteiraIntegradores.PainelPotencia).items = dados.map(p => ({ id: p, nome: p }));

      this.carregandoService.esconde('buscarPaineis');
    }, (erro) => {
      this.carregandoService.esconde('buscarPaineis');
      this.notificacaoService.erro(erro);
    });
  }

  buscarMarcaInversores() {
    this.carregandoService.mostra('buscarMarcaInversores');

    this.marcaService.listarPorFamilia(3).subscribe(
      (result) => {
        this.filtros.find(p => p.id === TipoFiltroCarteiraIntegradores.InversorMarca).items = result;

        this.carregandoService.esconde('buscarMarcaInversores');
      },
      (erro) => {
        this.carregandoService.esconde('buscarMarcaInversores');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarMarcaPaineis() {
    this.carregandoService.mostra('buscarMarcaPaineis');

    this.marcaService.listarPorFamilia(2).subscribe(
      (result) => {
        this.filtros.find(p => p.id === TipoFiltroCarteiraIntegradores.PainelMarca).items = result;

        this.carregandoService.esconde('buscarMarcaPaineis');
      },
      (erro) => {
        this.carregandoService.esconde('buscarMarcaPaineis');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarFormasDePagamento() {
    this.carregandoService.mostra('buscaFormasDePagamento');
    this.formadePagamentoService.consultar().subscribe(forms => {
      this.filtros.find(p => p.id === TipoFiltroCarteiraIntegradores.FormaDePagamento).items = forms;

      this.carregandoService.esconde('buscaFormasDePagamento');
    }, (erro) => {
      this.carregandoService.esconde('buscaFormasDePagamento');
      this.notificacaoService.erro(erro);
    });


  }

  buscarCondicoesDePagamento() {
    const formaDePagamentoSelecionado = this.filtros.find(p => p.id === TipoFiltroCarteiraIntegradores.FormaDePagamento).valor;
    this.carregandoService.mostra('buscaCondicoesDePagamento');
    this.condicaoDePagamentoService.consultarPorForma(formaDePagamentoSelecionado).subscribe(conds => {
      this.filtros.find(p => p.id === TipoFiltroCarteiraIntegradores.CondicaoDePagamento).items = conds;

      this.carregandoService.esconde('buscaCondicoesDePagamento');
    }, (erro) => {
      this.carregandoService.esconde('buscaCondicoesDePagamento');
      this.notificacaoService.erro(erro);
    });
  }

  limparCondicaoDePagamentoSelecionada() {
    this.filtros.find(p => p.id === TipoFiltroCarteiraIntegradores.CondicaoDePagamento).valor = undefined;
  }

  buscarCidades() {
    const ufSelecionado = this.filtros.find(p => p.id === TipoFiltroCarteiraIntegradores.UF).valor as string;
    this.carregandoService.mostra('buscaCidades');
    this.ibgeService.consultarPorEstado(ufSelecionado).subscribe((ibges: Ibge[]) => {
      this.filtros.find(p => p.id === TipoFiltroCarteiraIntegradores.Cidade).items = ibges;

      this.carregandoService.esconde('buscaCidades');
    }, (erro) => {
      this.carregandoService.esconde('buscaCidades');
      this.notificacaoService.erro(erro);
    });
  }

  limparCidadeSelecionada() {
    this.filtros.find(p => p.id === TipoFiltroCarteiraIntegradores.Cidade).valor = undefined;
  }

  buscarTags() {
    this.carregandoService.mostra('buscarTags');

    this.tagService.consultarTags(TipoTag.integrador).subscribe(
      (tags) => {
        this.filtros.find(p => p.id === TipoFiltroCarteiraIntegradores.Tags).items = tags;

        this.carregandoService.esconde('buscarTags');
      },
      (erro) => {
        this.carregandoService.esconde('buscarTags');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarClassificacao() {
    this.carregandoService.mostra('buscarClassificacao');

    this.segmentacaoService.consultar().subscribe(dados => {
      this.filtros.find(p => p.id === TipoFiltroCarteiraIntegradores.Classificacao).items = dados;

      this.carregandoService.esconde('buscarClassificacao');
    }, (erro) => {
      this.carregandoService.esconde('buscarClassificacao');
      this.notificacaoService.erro(erro);
    });
  }

  buscarUsarTelhadoCeramico() {

    this.carregandoService.mostra('consultarEstruturasPersonalizadas');
    this.premissasService.consultarEstruturasPersonalizadas().subscribe(
      (dados) => {
        this.estruturasPersonalizadas = dados;
        this.carregandoService.mostra('consultarUsarTelCeramico');
        this.premissasService.consultarUsarTelCeramico().subscribe(
          (f) => {

            let telhados = [];

            if (f.valor) {
              telhados = [
                ...[
                  { id: 0, nome: 'Cerâmico' },
                  { id: 1, nome: 'Fibrocimento' },
                  { id: 8, nome: this.estruturasPersonalizadas.textoFibrometal },
                  { id: 4, nome: 'Metálico' },
                  { id: 7, nome: 'Mini trilho ' },
                  { id: 5, nome: 'Laje' },
                  { id: 6, nome: 'Solo' },
                ],
              ];
            } else {
              telhados = [
                ...[
                  { id: 9, nome: 'Colonial' },
                  { id: 10, nome: 'Romana/Americana' },
                  { id: 1, nome: 'Fibrocimento' },
                  { id: 8, nome: this.estruturasPersonalizadas.textoFibrometal },
                  { id: 4, nome: 'Metálico' },
                  { id: 7, nome: 'Mini trilho ' },
                  { id: 5, nome: 'Laje' },
                  { id: 6, nome: 'Solo' },
                ],
              ];
            }

            if (this.estruturasPersonalizadas.usarEstruturaCalhetao) {
              telhados.push({ id: 12, nome: this.estruturasPersonalizadas.textoEstruturaCalhetao });
            }

            if (this.estruturasPersonalizadas.usarEstruturaCarport) {
              telhados.push({ id: 13, nome: this.estruturasPersonalizadas.textoEstruturaCarport });
            }

            this.filtros.find(p => p.id === TipoFiltroCarteiraIntegradores.TipoTelhado).items = telhados;

            this.carregandoService.esconde('consultarUsarTelCeramico');
          },
          (erro) => {
            this.carregandoService.esconde('consultarUsarTelCeramico');
            this.notificacaoService.erro(erro);
          }
        );

        this.carregandoService.esconde('consultarEstruturasPersonalizadas');
      },
      (erro) => {
        this.carregandoService.esconde('consultarEstruturasPersonalizadas');
        this.notificacaoService.erro(erro);
      }
    );


  }



  buscarMostrarBifasico() {
    this.carregandoService.mostra('buscarMostrarBifasico');
    this.premissasService.consultarMostrarBifasico().subscribe(
      (f) => {
        if (f.valor) {
          this.filtros.find(p => p.id === TipoFiltroCarteiraIntegradores.Fase).items[0].nome = 'Monofásico/Bifásico';
          this.filtros.find(p => p.id === TipoFiltroCarteiraIntegradores.Fase).items = [...this.filtros.find(p => p.id === TipoFiltroCarteiraIntegradores.Fase).items];
        }
        this.carregandoService.esconde('buscarMostrarBifasico');
      },
      (erro) => {
        this.carregandoService.esconde('buscarMostrarBifasico');
        this.notificacaoService.erro(erro);
      }
    );
  }

  filtrar() {

    this.filtrosSelecionados = this.filtros.filter(p => p.status &&
      (
        (p.tipo !== TipoCampoFiltroCarteiraIntegradores.campoDePara && p.tipo !== TipoCampoFiltroCarteiraIntegradores.comboMultiplo && p.valor !== undefined && p.valor !== null) ||
        (p.tipo === TipoCampoFiltroCarteiraIntegradores.campoDePara &&
          (p.valor as FiltroCarteiraIntegradoresDeAte).de !== undefined && (p.valor as FiltroCarteiraIntegradoresDeAte).ate !== undefined) ||
        (p.tipo === TipoCampoFiltroCarteiraIntegradores.comboMultiplo && p.valor !== undefined && p.valor !== null && (p.valor as []).length > 0))).map(p => ({
      id: p.id,
      tipo: p.tipo,
      valor: p.valor
    }));

    this.dialogRef.close(
      {
        filtrosSelecionados: this.filtrosSelecionados,
        descricaoFiltro: this.descricaoFiltro,
        idFiltro: this.idFiltro
      }
    );
  }

  salvarConsultaNova() {
    swal({
      title: 'Salvar consulta',
      text: 'Digite o nome da nova consulta no campo abaixo',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Salvar',
      cancelButtonText: 'Cancelar',
      buttonsStyling: false,
      type: 'info',
      input: 'text',
      inputValidator: (value) => {
        if (!value) {
          return 'O nome da consulta é obrigatório!';
        }

        this.carregandoService.mostra('salvaConsulta');


        const filtros = this.filtros.filter(p => p.status &&
          (
            (p.tipo !== TipoCampoFiltroCarteiraIntegradores.campoDePara && p.tipo !== TipoCampoFiltroCarteiraIntegradores.comboMultiplo && p.valor !== undefined && p.valor !== null) ||
            (p.tipo === TipoCampoFiltroCarteiraIntegradores.campoDePara &&
              (p.valor as FiltroCarteiraIntegradoresDeAte).de !== undefined && (p.valor as FiltroCarteiraIntegradoresDeAte).ate !== undefined) ||
            (p.tipo === TipoCampoFiltroCarteiraIntegradores.comboMultiplo && p.valor !== undefined && p.valor !== null && (p.valor as []).length > 0))).map(p => ({
          id: p.id,
          tipo: p.tipo,
          valor: p.valor
        }));

        const consulta = {
          filtros: filtros,
          colunas: this.colunasSelecionadas
        };

        const idVendedor = this.usuarioLogado.id;

        const novoFiltro: CarteiraDeIntegradoresFiltroBanco = {
          idVendedor: idVendedor,
          descricao: value,
          filtrosJson: JSON.stringify(consulta),
        };

        this.carteiraDeIntegradoresFiltrosService.salvarFiltro(novoFiltro).subscribe(
          (idFiltro) => {
            this.idFiltro = idFiltro;
            this.descricaoFiltro = value;
            this.carregandoService.esconde('salvaConsulta');
            this.notificacaoService.sucesso('Consulta salva com sucesso!!!');
          },
          (err) => {
            this.carregandoService.esconde('salvaConsulta');
            this.notificacaoService.erro(err);
          }
        );
      }
    }).then((result) => {
      if (result.value) { }
    });
  }

  salvarConsulta() {
    if (!this.idFiltro) {
      this.salvarConsultaNova();
    } else {
      swal({
        title: 'Salvar consulta',
        // text: 'Deseja sobrescrever a consulta atual ou criar uma nova?',
        html: 'Deseja sobrescrever a consulta <span class="bold">' + this.descricaoFiltro + '</span> ou criar uma nova?',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-info',
        cancelButtonClass: 'btn btn-success',
        confirmButtonText: 'Sim, sobrescrever',
        cancelButtonText: 'Não, criar uma nova',
        buttonsStyling: false,
        type: 'question',
      }).then((result) => {
        if (result.value) {
          this.carregandoService.mostra('salvaFiltro');

          const filtros = this.filtros.filter(p => p.status &&
            (
              (p.tipo !== TipoCampoFiltroCarteiraIntegradores.campoDePara && p.tipo !== TipoCampoFiltroCarteiraIntegradores.comboMultiplo && p.valor !== undefined && p.valor !== null) ||
              (p.tipo === TipoCampoFiltroCarteiraIntegradores.campoDePara &&
                (p.valor as FiltroCarteiraIntegradoresDeAte).de !== undefined && (p.valor as FiltroCarteiraIntegradoresDeAte).ate !== undefined) ||
              (p.tipo === TipoCampoFiltroCarteiraIntegradores.comboMultiplo && p.valor !== undefined && p.valor !== null && (p.valor as []).length > 0))).map(p => ({
            id: p.id,
            tipo: p.tipo,
            valor: p.valor
          }));

          const consulta = {
            filtros: filtros,
            colunas: this.colunasSelecionadas
          };

          const idVendedor = this.usuarioLogado.id;

          const updateFiltro: CarteiraDeIntegradoresFiltroBanco = {
            id: this.idFiltro,
            idVendedor: idVendedor,
            descricao: this.descricaoFiltro,
            filtrosJson: JSON.stringify(consulta),
          };

          this.carteiraDeIntegradoresFiltrosService.salvarFiltro(updateFiltro).subscribe(
            () => {
              this.carregandoService.esconde('salvaFiltro');
              this.notificacaoService.sucesso('Consulta salva com sucesso!!!');
            },
            (err) => {
              this.carregandoService.esconde('salvaFiltro');
              this.notificacaoService.erro(err);
            });
        } else if (result.dismiss == swal.DismissReason.cancel) {
          this.salvarConsultaNova();
        }
      });
    }
  }

  limparFiltros() {
    this.filtros = this.filtros.map(p => {
      p.status = false;
      p.valor = {};
      return p;
    });
  }
}
